import IconChevronLeft from '@apollo/icons/default/IconChevronLeft.svg';
import { Button } from '@apollo/orbit';
import React from 'react';
import { Link } from 'react-router-dom';

import { NotFound } from 'src/components/common/notFound/NotFound';

export const GraphNotFound = () => (
  <NotFound
    image="satellite"
    title="Oops, no sign of life here..."
    subtitle={
      <>
        <div className="mb-8">
          The graph you are looking for could not be found. Please go back to
          the <b>Graph List</b> and select another graph.
        </div>
        <Button
          leftIcon={<IconChevronLeft />}
          as={Link}
          to="/"
          variant="primary"
        >
          Graph List
        </Button>
      </>
    }
  />
);
